import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-skeleton-card',
  imports: [CommonModule],
  template: `
    <div
      class="skeleton-card"
      [ngStyle]="{
        width: width(),
        height: height(),
      }"
      [ngClass]="backgroundColorClass()"
    ></div>
  `,
  styles: [
    `
      .skeleton-card {
        /* background is now set via class */
        border-radius: 8px;
        position: relative;
        overflow: hidden;
      }
      .skeleton-card::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
        animation: shimmer 1.2s infinite;
      }
      @keyframes shimmer {
        0% {
          transform: translateX(-100%);
        }
        100% {
          transform: translateX(100%);
        }
      }
    `,
  ],
})
export class SkeletonComponent {
  /**
   * Width, can be in px, %, etc.
   */
  public readonly width = input('100%');
  /**
   * Height, can be in px, %, etc.
   */
  public readonly height = input('150px');
  /**
   * Background color class, e.g. 'bg-gray-200'
   */
  public readonly backgroundColorClass = input('bg-gray-200');
}
